import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';
const services = [{
  name: 'Degradé',
  includes: 'Perfilado + Cejas (incluido gratis)',
  duration: '50 min',
  price: '$540'
}, {
  name: 'Degradé + Barba + Cejas',
  includes: 'Corte degradé + barba + cejas',
  duration: '50 min',
  price: '$760'
}, {
  name: 'Corte clásico',
  includes: 'Corte clásico + terminación prolija',
  duration: '50 min',
  price: '$490'
}, {
  name: 'Mechas platinadas + corte y cejas',
  includes: 'Mechas platinadas + corte + cejas',
  duration: '100 min',
  price: '$1990'
}];
export function ServicesSection() {
  return <section id="servicios" className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-237">
      <div className="text-center mb-14" data-id="element-238">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-239">
          Servicios
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-gray-400 max-w-2xl mx-auto" data-id="element-240">
          Elegí tu servicio y conocé el detalle de duración y precio. Coordiná
          tu turno en la agenda online.
        </motion.p>
      </div>

      {/* Desktop: clean row layout */}
      <div className="hidden md:block" data-id="element-241">
        {/* Header row */}
        <div className="grid grid-cols-[1fr_1.2fr_auto_auto_auto] gap-6 px-6 pb-4 border-b border-gold/15 text-xs text-gold/70 uppercase tracking-widest font-semibold" data-id="element-242">
          <span data-id="element-243">Servicio</span>
          <span data-id="element-244">Incluye</span>
          <span className="text-center" data-id="element-245">Duración</span>
          <span className="text-right" data-id="element-246">Precio</span>
          <span className="w-[140px]" data-id="element-247" />
        </div>

        {/* Service rows */}
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.08
      }} data-id="element-248">
            <div className="grid grid-cols-[1fr_1.2fr_auto_auto_auto] gap-6 items-center px-6 py-5" data-id="element-249">
              <h3 className="text-white font-bold text-base" data-id="element-250">{service.name}</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-251">
                {service.includes}
              </p>
              <div className="flex justify-center" data-id="element-252">
                <span className="inline-flex items-center gap-1.5 text-xs text-gray-400 bg-white/5 border border-white/5 px-3 py-1.5 rounded-full" data-id="element-253">
                  <Clock size={12} className="text-gold/60" data-id="element-254" />
                  {service.duration}
                </span>
              </div>
              <p className="text-right text-gold font-bold text-2xl" data-id="element-255">
                {service.price}
              </p>
              <a href="#sucursales" className="group inline-flex items-center justify-center gap-1.5 bg-gold/10 hover:bg-gold text-gold hover:text-dark border border-gold/30 hover:border-gold font-semibold text-xs uppercase tracking-wider px-4 py-2 rounded-full transition-all duration-300 whitespace-nowrap" aria-label={`Reservar ${service.name}`} data-id="element-256">
                <span data-id="element-257">Reservar</span>
                <ArrowRight size={12} className="group-hover:translate-x-0.5 transition-transform" data-id="element-258" />
              </a>
            </div>
            {index < services.length - 1 && <div className="mx-6 border-b border-white/[0.06]" data-id="element-259" />}
          </motion.div>)}
      </div>

      {/* Mobile: stacked compact cards */}
      <div className="md:hidden space-y-4" data-id="element-260">
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.08
      }} className="bg-dark-card border border-white/5 rounded-xl p-5 space-y-3" data-id="element-261">
            <div className="flex items-start justify-between gap-3" data-id="element-262">
              <h3 className="text-white font-bold text-base leading-snug" data-id="element-263">
                {service.name}
              </h3>
              <span className="text-gold font-bold text-xl whitespace-nowrap" data-id="element-264">
                {service.price}
              </span>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-265">{service.includes}</p>
            <div className="flex items-center justify-between gap-3 pt-1" data-id="element-266">
              <span className="inline-flex items-center gap-1.5 text-xs text-gray-500 bg-white/5 border border-white/5 px-2.5 py-1 rounded-full" data-id="element-267">
                <Clock size={12} className="text-gold/60" data-id="element-268" />
                {service.duration}
              </span>
              <a href="#sucursales" className="group inline-flex items-center gap-1.5 bg-gold/10 hover:bg-gold text-gold hover:text-dark border border-gold/30 hover:border-gold font-semibold text-xs uppercase tracking-wider px-3.5 py-1.5 rounded-full transition-all duration-300" aria-label={`Reservar ${service.name}`} data-id="element-269">
                <span data-id="element-270">Reservar</span>
                <ArrowRight size={12} className="group-hover:translate-x-0.5 transition-transform" data-id="element-271" />
              </a>
            </div>
          </motion.div>)}
      </div>
    </section>;
}